import { Route, Routes } from 'react-router-dom';

import DocumentSubmissionCompletePage from './routes/DocumentSubmissionCompletePage';
import HomePage from './routes/HomePage';
import NotFoundPage from './routes/NotFoundPage';
import RedirectPage from './routes/RedirectPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/redirect" element={<RedirectPage />} />
      <Route path="/document-submission-complete" element={<DocumentSubmissionCompletePage />} />
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
